import {Component} from 'react';
import PropTypes from 'prop-types';
import {Form} from 'semantic-ui-react';
import OptionalTitle from './OptionalTitle';

export default class EditableFormSection extends Component {
  static propTypes = {
    sectionData: PropTypes.object.isRequired,
    onUpdateData: PropTypes.func.isRequired,
    valueElementProps: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      priceValue: props.sectionData.value || '',
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sectionData.value !== this.props.sectionData.value) {
      this.setState({priceValue: this.props.sectionData.value});
    }
  }

  onChange = (event, {value}) => {
    if (value !== this.state.priceValue) {
      this.setState({priceValue: value});
    }
    event.stopPropagation();
  };

  onBlur = () => {
    const {priceValue} = this.state;
    this.props.onUpdateData({value: priceValue});
  };

  render() {
    const {sectionData, valueElementProps, onUpdateData} = this.props;
    const {priceValue} = this.state;
    const {isEnabled = true} = sectionData;
    return (
      <div>
        <OptionalTitle onUpdateData={onUpdateData} title={sectionData.title} isEnabled={isEnabled}/>
        {isEnabled && (
          <Form.Field {...valueElementProps}
            className="sectionDataValue"
            name="sectionData"
            onBlur={this.onBlur}
            onChange={this.onChange}
            value={priceValue}
          />
        )}
      </div>
    );
  }
}
